import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, Star } from 'lucide-react';
const testimonials = [{
  initial: 'G',
  name: 'Gabriel T.',
  role: 'Psiquiatra · Buenos Aires',
  text: '"Me salvó de un sumario administrativo. Un paciente se fugó en mi guardia y gracias a que había documentado exactamente como indica el Tomo II, la dirección médica me desvinculó de toda responsabilidad. Mi matrícula está intacta."',
  color: 'bg-blue-600'
}, {
  initial: 'M',
  name: 'Marcela R.',
  role: 'Psiquiatra Hospital Público',
  text: '"El Tomo III, el del escudo legal, me abrió los ojos. Nunca dimensioné el riesgo que corría sin consentimientos claros y sin registrar mis decisiones de riesgo. Ahora trabajo con una tranquilidad que antes no tenía."',
  color: 'bg-purple-600'
}, {
  initial: 'V',
  name: 'Valentín F.',
  role: 'Residente · Córdoba',
  text: '"Entré a mi primera guardia aterrado por la Ley 26.657. El Megapack me dio el paso a paso exacto para una internación involuntaria sin dejar huecos legales. El juez avaló la medida sin un solo pero."',
  color: 'bg-green-600'
}, {
  initial: 'C',
  name: 'Camila P.',
  role: 'Residente · La Plata',
  text: '"Las plantillas de evolución diaria son un antes y un después. Antes escribía páginas enteras y sentía que igual quedaba expuesta. Ahora en 5 minutos dejo una nota blindada que me protege ante cualquier auditoría."',
  color: 'bg-orange-600'
}, {
  initial: 'M',
  name: 'Martín D.',
  role: 'Residente · Mendoza',
  text: '"El Tomo VI tiene todo lo que la residencia no te enseña. Cómo manejar el conflicto con jefatura, cómo documentarte cuando recibís una guardia desastrosa. Es el tomo que más necesitaba para sobrevivir el sistema."',
  color: 'bg-teal-600'
}, {
  initial: 'A',
  name: 'Agustina B.',
  role: 'Residente · Tucumán',
  text: '"Soy de primer año y el miedo a equivocarme y que me cueste la carrera me paralizaba. Este sistema me dio la estructura legal que ningún ateneo te da. Hoy los jefes me preguntan cómo sé tanto sobre documentación."',
  color: 'bg-pink-600'
}, {
  initial: 'F',
  name: 'Federico T.',
  role: 'Psiquiatra · Mar del Plata',
  text: '"El Bono de Ley 26.657 es oro puro. Antes, recibir un habeas corpus me generaba pánico. Ahora sé exactamente qué documentar, en qué plazo notificar y cómo responder con total seguridad jurídica."',
  color: 'bg-indigo-600'
}];
export function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  useEffect(() => {
    if (isHovered) return;
    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [isHovered]);
  const handleDragEnd = (e: any, {
    offset
  }: any) => {
    const swipe = offset.x;
    if (swipe < -50) setCurrentIndex(prev => (prev + 1) % testimonials.length);else if (swipe > 50) setCurrentIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  };
  return <section className="py-8 md:py-20 bg-white overflow-hidden" data-id="element-266">
      <div className="max-w-6xl mx-auto px-4" data-id="element-267">
        <div className="text-center mb-6 md:mb-10" data-id="element-268">
          <h2 className="text-[10px] md:text-sm font-bold text-brand-mid tracking-wider uppercase mb-1" data-id="element-269">
            +800 PROFESIONALES LO USAN
          </h2>
          <h3 className="font-heading text-lg md:text-3xl text-brand-dark" data-id="element-270">
            Lo que dicen los profesionales
          </h3>
          <div className="flex items-center justify-center gap-0.5 mt-1.5 md:mt-3" data-id="element-271">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 md:w-5 md:h-5 text-yellow-400 fill-yellow-400" data-id="element-272" />)}
            <span className="ml-1.5 md:ml-2 font-bold text-gray-700 text-xs md:text-base" data-id="element-273">
              4.9/5
            </span>
          </div>
        </div>

        {/* Desktop View */}
        <div className="hidden md:flex gap-6 justify-center" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} data-id="element-274">
          {[0, 1, 2].map(offset => {
          const index = (currentIndex + offset) % testimonials.length;
          const t = testimonials[index];
          return <motion.div key={`${index}-${offset}`} initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.5
          }} className="bg-brand-bg border-l-4 border-brand-dark p-6 rounded-r-xl shadow-sm flex-1 max-w-sm hover:shadow-md transition-shadow" data-id="element-275">
                <div className="flex items-center gap-3 mb-4" data-id="element-276">
                  <div className={`w-10 h-10 rounded-full text-white flex items-center justify-center font-bold text-lg ${t.color}`} data-id="element-277">
                    {t.initial}
                  </div>
                  <div data-id="element-278">
                    <div className="font-bold text-gray-900 text-sm" data-id="element-279">
                      {t.name}
                    </div>
                    <div className="text-xs text-gray-500" data-id="element-280">{t.role}</div>
                  </div>
                </div>
                <p className="text-sm text-gray-700 italic mb-4 line-clamp-5" data-id="element-281">
                  {t.text}
                </p>
                <div className="flex items-center gap-1 text-xs font-semibold text-green-600" data-id="element-282">
                  <Check className="w-3 h-3" data-id="element-283" /> Verificado
                </div>
              </motion.div>;
        })}
        </div>

        {/* Mobile View */}
        <div className="md:hidden relative h-[180px]" data-id="element-284">
          <AnimatePresence mode="wait" data-id="element-285">
            <motion.div key={currentIndex} initial={{
            opacity: 0,
            x: 30
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -30
          }} transition={{
            duration: 0.3
          }} drag="x" dragConstraints={{
            left: 0,
            right: 0
          }} onDragEnd={handleDragEnd} className="absolute inset-0 bg-brand-bg border-l-4 border-brand-dark p-3.5 rounded-r-xl shadow-sm flex flex-col justify-between" data-id="element-286">
              <div data-id="element-287">
                <div className="flex items-center gap-2.5 mb-2" data-id="element-288">
                  <div className={`w-9 h-9 rounded-full text-white flex items-center justify-center font-bold text-sm shrink-0 ${testimonials[currentIndex].color}`} data-id="element-289">
                    {testimonials[currentIndex].initial}
                  </div>
                  <div className="min-w-0" data-id="element-290">
                    <div className="font-bold text-gray-900 text-xs leading-tight" data-id="element-291">
                      {testimonials[currentIndex].name}
                    </div>
                    <div className="text-[10px] text-gray-500 line-clamp-1" data-id="element-292">
                      {testimonials[currentIndex].role}
                    </div>
                  </div>
                </div>
                <p className="text-[12px] text-gray-700 italic line-clamp-4 leading-snug" data-id="element-293">
                  {testimonials[currentIndex].text}
                </p>
              </div>
              <div className="flex items-center gap-1 text-[10px] font-semibold text-green-600 mt-1" data-id="element-294">
                <Check className="w-2.5 h-2.5" data-id="element-295" /> Verificado
              </div>
            </motion.div>
          </AnimatePresence>
          <div className="absolute -bottom-5 left-0 right-0 flex justify-center gap-1" data-id="element-296">
            {testimonials.map((_, i) => <button key={i} onClick={() => setCurrentIndex(i)} aria-label={`Testimonio ${i + 1}`} className={`h-1.5 rounded-full transition-all ${i === currentIndex ? 'w-4 bg-brand-dark' : 'w-1.5 bg-gray-300'}`} data-id="element-297" />)}
          </div>
        </div>
      </div>
    </section>;
}